module.exports = __webpack_public_path__ + "alertminerbadge.e399d86d61ad4f7563c1.png";